import * as UrlList from "./network/urlList";

const token = localStorage.getItem("course-tool-token");
// 打包环境 dev test prod testSyncProd
const environment = "";

/** * 默认环境
 * 开发环境 dev
 * 测试环境 test
 * 测试环境无版本 testSyncProd
 * 预发布版本 pre
 * 正式版本 prod
 ** */
let env = "prod";
if (environment) env = environment;

const devConfig = {
  isRelease: false,
  web_url: "https://course-editor-look.caihonggou.com",
  token,
  ...UrlList.devPublicUrl, // 根据不同环境加载不同URL组
};

const testConfig = {
  isRelease: false,
  web_url: "https://course-editor-look.caihonggou.com",
  token,
  ...UrlList.testPublicUrl, // 根据不同环境加载不同URL组
};

const prodConfig = {
  isRelease: true,
  web_url: "https://course-editor-look.aikaola.com",
  token,
  ...UrlList.prodPublicUrl, // 根据不同环境加载不同URL组
};

const preConfig = {
  isRelease: false,
  web_url: "https://course-editor-look.aikaola.com",
  token,
  ...UrlList.prodPublicUrl, // 根据不同环境加载不同URL组
};

// 根据环境配置不同的配置
const conf =
  env === "dev"
    ? devConfig
    : env === "test" || env === "testSyncProd"
      ? testConfig
      : env === "prod"
        ? prodConfig
        : env === "pre"
          ? preConfig
          : null;
export default conf;
